/*
 * @Description:
 * @Autor: gxd
 * @Date: 2020-12-02 18:34:14
 * @LastEditors: gxd
 * @LastEditTime: 2020-12-09 15:05:19
 */
export default [
  '1. 上传截图时间为2020年11月10日-2021年1月10日，以自然周为周期，当周分享海报当周上传审核。',
  '2. 审核成功：当周上传的截图审核成功并获得1次奖励次数，可在礼品页面点击“当前可兑换次数’查看奖励明细。',
  '3. 审核失败：当周上传的截图不符合审核要求。当周审核失败后可在当周周日24点之前，按照“截图示例’上传正确截图，就可获得当周奖励。常见的失败原因如下：',
  '· 分享未加邀请语；',
  '· 海报在朋友圈保留不足2小时；',
  '· 未分享此活动海报；',
  '· 朋友圈进行了分组或私密；',
  '4. 审核中：上传当周截图后，审核人员将在2个工作日内审核完成。',
  '5. 未参与：当周内未上传过截图。',
  '6. 待开始：未到活动时间。',
  '7. 待上传：可以上传当周的朋友圈截图。',
  '8. 截止上传：未在规定时间内上传补卡截图。',
  '9. 补卡：当周上传过截图且由于系统原因造成的未审核用户，才有补卡机会。请在截止日期内上传对应周期的截图，否则将无法进行补卡。无补卡标志的不能补卡。',
  '10. 过期：当周活动已结束，不能补卡也不能重新上传截图。'
]
